@if (registrationForm) {
  <form class="registration-form-wrapper" [ngClass]="{ 'embed-form': embed }" [formGroup]="registrationForm">
    @if (event.logoImageId && event.logoImageURI) {
      <img class="event-logo" [src]="event.logoImageURI" alt="Event logo image" />
    }
    @if (event.name) {
      <h1 class="event-name" [title]="event.name">
        {{ event.name | truncate: 64 }}
      </h1>
    }
    <p class="event-registration">Event Registration</p>
    @if (event.startDateTime) {
      <p class="event-time">
        <mat-icon>calendar_today</mat-icon>
        <span>{{ event.startDateTime | date: 'MMM d, y, h:mm a' }} {{ timezone }}</span>
      </p>
    }
    @if (event.description && showFields) {
      <p class="event-description" [title]="event.description">
        {{ event.description | truncate: 256 }}
      </p>
    }
    @if (showFields) {
      @for (field of registrationFields; track field) {
        @if (field.name === profilePictureTitle) {
          <div class="profile-picture-wrapper">
            <div class="profile-picture">
              @if (profilePicture) {
                <img [src]="profilePicture" alt="User Generated Image" />
              } @else {
                <span>
                  {{ avatarLetters }}
                </span>
              }
            </div>
            <button class="change-picture" [disabled]="isPreview" type="button" (click)="openProfilePictureModal()">
              Upload Profile Picture
              {{ field.required ? '*' : '' }}
            </button>
          </div>
        } @else {
          @switch (field.inputType) {
            @case (questionInputType.PARAGRAPH) {
              <mat-form-field class="badging-form" appearance="outline">
                <mat-label>{{ field.name }}</mat-label>
                <textarea
                  type="text"
                  attr.aria-label="{{ field.name }}"
                  placeholder="{{ field.name }}"
                  formControlName="{{ field.name }}"
                  required="{{ field.required }}"
                  [readonly]="isPreview"
                  matInput
                ></textarea>

                <mat-hint>{{ field.description }}</mat-hint>
                <mat-hint align="end"> {{ getTextAreaValueCount(field.name) }} / 2000 </mat-hint>

                <mat-error>
                  <div class="textarea-error-message">
                    {{ getErrorMessage(field.name ?? '') }}
                  </div>
                </mat-error>
              </mat-form-field>
            }
            @case (questionInputType.SINGLE_SELECT) {
              <mat-form-field class="badging-form" appearance="outline">
                <mat-label>{{ field.name }}</mat-label>
                <mat-select
                  attr.aria-label="{{ field.name }}"
                  placeholder="{{ field.name }}"
                  formControlName="{{ field.name }}"
                  required="{{ field.required }}"
                  multiple="{{ field.inputType !== questionInputType.SINGLE_SELECT }}"
                  matInput
                >
                  @for (item of field.options; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
                <mat-hint> {{ field.description }}</mat-hint>
                <mat-error>
                  {{ getErrorMessage(field.name ?? '') }}
                </mat-error>
              </mat-form-field>
            }
            @case (questionInputType.MULTI_SELECT) {
              <mat-form-field class="badging-form" appearance="outline">
                <mat-label>{{ field.name }}</mat-label>
                <mat-select
                  attr.aria-label="{{ field.name }}"
                  placeholder="{{ field.name }}"
                  formControlName="{{ field.name }}"
                  required="{{ field.required }}"
                  multiple
                  matInput
                >
                  @for (item of field.options; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
                <mat-hint>{{ field.description }}</mat-hint>
                <mat-error>
                  {{ getErrorMessage(field.name ?? '') }}
                </mat-error>
              </mat-form-field>
            }
            @case (questionInputType.NUMBER) {
              <mat-form-field class="badging-form" appearance="outline">
                <mat-label>{{ field.name }}</mat-label>
                <input
                  type="number"
                  inputmode="numeric"
                  pattern="\d*"
                  attr.aria-label="{{ field.name }}"
                  placeholder="{{ field.name }}"
                  formControlName="{{ field.name }}"
                  [readonly]="isPreview"
                  matInput
                />
                <mat-hint>{{ field.description }}</mat-hint>
                <mat-error>
                  {{ getErrorMessage(field.name ?? '') }}
                </mat-error>
              </mat-form-field>
            }
            @default {
              <mat-form-field class="badging-form w-full" appearance="outline">
                <mat-label>Enter your {{ field.name }}</mat-label>
                <input
                  matInput
                  attr.aria-label="{{ field.name }}"
                  placeholder="{{ field.name }}"
                  formControlName="{{ field.name }}"
                  required="{{ field.required }}"
                  [readonly]="isPreview"
                />
                <mat-hint> {{ field.description }}</mat-hint>
                <mat-error>
                  {{ getErrorMessage(field.name ?? '') }}
                </mat-error>
              </mat-form-field>
            }
          }
        }
      }
      @if (!isPreview) {
        <button
          class="submit-button"
          [style]="{ background: event.buttonColor, color: event.buttonTextColor }"
          [ngClass]="{ 'custom-event-button': !!event.buttonColor }"
          [disabled]="registrationForm.invalid"
          (click)="submitForm()"
        >
          Submit
        </button>
      }
      @if (event.eventLink?.includes('midmarketstrategiesforenhancingmobilesecurityandinfrastructure')) {
        <div>Privacy Policy</div>
        <div class="consent-form">
          <p>
            IDC and Foundry will pass contact information of event attendees to IBM, so that they may follow up with you
            and continue the conversation. Use of your contact information by IBM will be governed by
            <a target="_blank" href="https://www.ibm.com/privacy?lnk=flg-priv-usen%3flnk=flg">IBM's Privacy Policy</a>.
          </p>
          <p>
            Additionally, IBM would love to keep you well-informed of relevant updates and content on this topic. To
            stay connected with you after the event please select your preferences below. I’d like my contact details to
            be shared with IBM so they can keep me informed about products, services, and offers. More information on
            how IBM uses data and ways to
            <a target="_blank" href="https://www.ibm.com/account/reg/us-en/signup?formid=urx-42537">opt out</a> can be
            found in the <a target="_blank" href="https://www.ibm.com/us-en/privacy">IBM Privacy Statement</a>.
            California residents,
            <a target="_blank" href="https://www.ibm.com/us-en/privacy/ccpa"
              >review our notice and your privacy choices</a
            >.
          </p>
          <p>Email</p>
          <p>Phone</p>
          <p>
            By submitting this form, I acknowledge that I have read and understood the
            <a target="_blank" href="https://www.ibm.com/privacy">IBM Privacy Statement</a>.
          </p>
          <p>
            This event is provided in cooperation between IDC, IDG Communications d/b/a Foundry and the Partners, all
            acting as independent controllers. You may find more information about how each of them processes your
            personal data in their privacy policy:
            <a target="_blank" href="https://www.idc.com/about/privacy">IDC Privacy Policy</a>,
            <a target="_blank" href="https://foundryco.com/idg-privacy-policy/">Foundry Privacy Policy</a> and the
            Partners’ privacy policy.
          </p>
          <p>
            IDC, Foundry and the Partners would like to keep in touch with you, using the contact details you have
            provided in this registration form, and inform you about their products and services they think you may find
            interesting. If you do not want to receive such information from IDC, Foundry and/or the Partners as a
            follow up to this event, you may let them know by following the instructions in any such communication or:
            (i) for IDC, by clicking <a target="_blank" href="https://www.idc.com/unsubscribe">here</a>; (ii) for
            Foundry, by emailing <a target="_blank" href="mailto://datarequest@idg.com/">here</a>.
          </p>
        </div>
      }
    } @else {
      <span>
        This event is currently not accepting registrants, please contact
        <strong
          ><a href="mailto:support@scoot.app">{{ 'support@scoot.app' }}</a></strong
        >
        for more information.
      </span>
    }
  </form>
}
